import { createRouter, createWebHistory } from 'vue-router'
import DashboardView from '../views/DashboardView.vue'
// import NotFound from '@/components/NotFound.vue'
import store from '@/store/index.js';

const routes = [
  {
    path: '/',
    alias: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresLogin: false }
  },
  {
    path: '/credentials',
    name: 'credentials',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/CredentialsView.vue'),
    meta: { requiresLogin: true }
  },
  {
    path: '/permissions',
    name: 'permissions',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/PermissionsView.vue'),
    meta: { requiresLogin: true }
  },
  {
    path: '/automations',
    name: 'automations',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AutomationsView.vue'),
    meta: { requiresLogin: true }
  },
  //{ path: '/', component: NotFound },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeResolve((to, from, next) => {
  const user = store.state.userData;  //store with namespaced  modules
  if (to.matched.some(record => record.meta.requiresLogin) && user == null) {
    if (from.name == 'dashboard') return false;
    next({ name: 'dashboard' })  //redirect to login
  } else {
    next() //proceed to the route
  }
});

router.beforeEach((to, from, next) => {
  document.title = 'Project Sundevil Dashboard';
  next();
});

export default router
